import FormContabilidad from "features/Contactos/forms/Contabilidad"
import { useTaxes } from "features/User/pages/Taxes/useTaxes"

import ContactosService from "common/services/ContactosService"
import useContactoDetails from "features/Contactos/hooks/useContactoDetails"
import mapContactoContabillidadFromApi from "features/Contactos/mappers/mapContactoContabillidadFromApi"
import { useParams } from "react-router-dom"
import "./styles.scss"

const Contabilidad = () => {
  const { id } = useParams()
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { taxes } = useTaxes()
  const { data, updateData } = useContactoDetails({
    id,
    fetch: ContactosService.getContactoContabilidad,
    update: ContactosService.updateContactoContabilidad,
  })

  return (
    <div className='contactos-contabilidad px-3'>
      <FormContabilidad
        // @ts-expect-error TS(2322): Type '{ data: { impuestosCompra: $TSFixMe; impuestosVen...
        data={mapContactoContabillidadFromApi(data)}
        updateData={updateData}
        taxes={taxes}
      />
    </div>
  )
}

export default Contabilidad
